import React, { Component } from 'react';
import './Slideshow.css';
import Icon from '../Icon/Icon';
import Slide from './Slide';

class Slideshow extends Component {
	state = {
		selectedSlide: 1,
		slideDots: [],
		navClasses: {
			prev: 'SlideNav Prev',
			next: 'SlideNav Next'
		},
		init: false
	};
	
	componentDidMount() {
		if( this.props.slides ) {
			const slideDots = this.props.slides.map( slide => {
				const slideDot = {
					id: slide.id,
					className: 'SlideButton',
					title: 'Go to Slide ' + slide.id
				};
				
				if( slide.id === 1 ) {
					slideDot.className += ' selected';
				}
				
				if (!slide.init) {
					if( this.props.displayTitle && slide.title) {
						slide.content = '<p class="slide-title">' + slide.title + '</p>' + slide.content;
						
					}
					
					if( this.props.displayID ) {
						let idText = slide.id.toString();
						if( idText.length < 2 ) {
							idText = '0' + idText;
						}
						slide.content = '<p class="slide-id">' + idText + '</p>' + slide.content;
					}

					slide.init = true;
				}
				
				slide.bgImage = this.props.bgImages + slide.id + '.jpg';
				
				return slideDot;
			});
			
			const navClasses = { ...this.state.navClasses };

			if( this.state.selectedSlide === 1 ) {
				navClasses.prev = 'SlideNav Prev disabled';
			}
			
			if( this.state.selectedSlide === this.props.slides.length ) {
				navClasses.next = 'SlideNav Next disabled';
			}
			
			this.setState({
				slideDots: slideDots,
				navClasses: navClasses
			});
		}
	}
	
	slideProgressHandler = ( slide ) => {
		const currentSlide = this.state.selectedSlide;
		let newSlide = null;
		
		if( slide ) {
			switch( slide ) {
				case 'next':
					newSlide = currentSlide + 1;
					break;
				
				case 'prev':
					newSlide = currentSlide - 1;
					break;
				
				default:
					newSlide = slide;
					break;
			}
			
			const navClasses = { ...this.state.navClasses };
			
			if( newSlide === 1 ) {
				navClasses.prev = 'SlideNav Prev disabled';
			}
			else {
				navClasses.prev = 'SlideNav Prev';
			}
			
			if( newSlide === this.props.slides.length ) {
				navClasses.next = 'SlideNav Next disabled';
			}
			else {
				navClasses.next = 'SlideNav Next';
			}
			
			const slideDots = this.state.slideDots.map( dot => {
				if( dot.id === newSlide ) {
					dot.className = 'SlideButton selected';
				}
				else {
					dot.className = 'SlideButton';
				}
				
				return dot;
			});
			
			this.setState({
				selectedSlide: newSlide,
				slideDots: slideDots,
				navClasses: navClasses
			});
		}
	}
	
	render() {
		return (
			<div className="SlideshowContainer">
				<div className="Slideshow">
					<div className={ this.state.navClasses.prev } onClick={ () => this.slideProgressHandler( 'prev' ) }>
						<Icon icon="arrow" title="Previous Slide" />
					</div>
					
					<div className="Slides">
						{
							this.props.slides.map( slide => (
								<Slide key={ slide.id } selectedSlide={ this.state.selectedSlide } { ...slide } />
							))
						}
					</div>
					
					<div className={ this.state.navClasses.next } onClick={ () => this.slideProgressHandler( 'next' ) }>
						<Icon icon="arrow" title="Next Slide" />
					</div>
				</div>
				
				<div className="SlideStatus">
					{
						this.state.slideDots.map( dot => (
							<span key={ dot.id } onClick={ () => this.slideProgressHandler( dot.id ) } { ...dot } />
						))
					}
				</div>
			</div>
		);
	}
}

export default Slideshow;



// WEBPACK FOOTER //
// ./src/components/Slideshow/Slideshow.js